
import { Transforms, Editor, Node, Path } from 'slate'
import isUrl from 'is-url'
import imageExtensions from './imageExtensions'
import { Registry } from '@react-registry'
import { placeholderImageSrc } from './placeholderImageSrc'
import { isSelectionCollapsed, insertImage, isImageUrl, moveCursorToNextEmptyTextNode } from './utils'
import { getNormalTextElement } from '../paragraph/utils'
import { nextNodePath } from '../../utils';
import {jsx} from 'slate-hyperscript';

export const handleImageError = (event) => {
  event.target.src = placeholderImageSrc
}

export const withImage = (editor) => {
  const { isVoid, insertData, deleteBackward, insertBreak, onChange } = editor

  editor.isVoid = (element) => {
    return element.type === 'img' ? true : isVoid(element)
  }

  editor.insertData = async (data) => {
    const text = data.getData('text/plain')
    const { files } = data
    if (files && files.length > 0) {
      for (const file of files) {
        const reader = new FileReader()
        const [mime] = file.type.split('/')
        if (mime === 'image') {
          reader.addEventListener('load', async () => {
            const url = reader.result
            await insertImage(editor, url)
          })
          reader.readAsDataURL(file)
        }
      }
    } else if (isImageUrl(text)) {
      await insertImage(editor, text)
    } else {
      insertData(data)
    }
  }

  editor.insertBreak = function () {
    const { selection } = editor;
    const isExpanded = !isSelectionCollapsed(selection);
    if (isExpanded) { // if expanded or no selection
      return insertBreak();
    }
    const currSelectionPath = selection?.anchor?.path;
    const currSelectionPathLen = currSelectionPath.length;
    const currSelectedComponent = Node.get(editor, currSelectionPath.slice(0, currSelectionPathLen - 1));
    const [parentElement, parentElementPath] = Editor.parent(editor,  currSelectionPath.slice(0, currSelectionPathLen - 1));
    if (!Editor.isVoid(editor, currSelectedComponent)) return insertBreak();
    if(parentElement['type'] === 'li' && Editor.isVoid(editor, currSelectedComponent)){
      const nextLiPath = Path.next(parentElementPath)
      Transforms.insertNodes(editor, jsx('element', { type: 'li' }), { at: nextLiPath })
      Transforms.select(editor, nextLiPath)
      Transforms.collapse(editor)
      return
    }
    if (Editor.isInline(editor, currSelectedComponent)) {
      const nextSelectionPath = nextNodePath(currSelectionPath.slice(0, currSelectionPathLen - 1));
      Transforms.select(editor, nextSelectionPath);
      insertBreak();
    } else {
      Transforms.insertNodes(editor, getNormalTextElement(), {
        at: [...currSelectionPath.slice(0, currSelectionPathLen - 2), currSelectionPath[currSelectionPathLen - 2] + 1],
        select: true
      });
    }
  }

  editor.deleteBackward = (unit) => {
    const { selection } = editor
    const isAtStart = selection?.anchor?.offset === 0
    const selectionPath = selection?.anchor?.path
    const selectionPathLength = selectionPath?.length - 1;
    if (isAtStart && selectionPathLength >= 1 && selectionPath[selectionPathLength - 1] !== 0) {

      //CASE 1: if curr node is void delete it
      const currNode = Node.get(editor, selectionPath.slice(0, selectionPathLength));
      if (Editor.isVoid(editor, currNode)) {
        return deleteBackward(unit);
      }

      // CASE 2: if prev sibling is void select it
      const prevSiblingPath = [
        ...selectionPath.slice(0, selectionPathLength - 1),
        selectionPath[selectionPathLength - 1] - 1
      ]
      const prevSibling = Node.get(editor, prevSiblingPath)

      if (Editor.isVoid(editor, prevSibling)) {
        return Transforms.select(editor, [...prevSiblingPath, 0]);
      }
      return deleteBackward(unit);
    }
    return deleteBackward(unit)
  }
  editor.onChange = (...data) => {
    moveCursorToNextEmptyTextNode(editor)
    return onChange(...data)
  }

  return editor
}



Registry.register(withImage, { id: 'withImage', registry: 'v2.plugin' })
